import { z } from 'zod';
import { ResourceTypeEnum } from './enum';

export type UserResourceSetListItem = z.infer<
  typeof schemaUserResourceSetListItem
>;
export const schemaUserResourceSetListItem = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
});

export type UserResourceDetail = z.infer<typeof schemaUserResourceDetail>;
export const schemaUserResourceDetail = z.object({
  resources: z.array(z.object({ id: z.number() })),
  resourceType: ResourceTypeEnum,
  sort: z.number(),
});

export type UserResourceSetItem = z.infer<typeof schemaUserResourceSetItem>;
export const schemaUserResourceSetItem = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
  resourceSetDetails: z.array(schemaUserResourceDetail),
});

export type UserResourceSetCreateBody = z.infer<
  typeof schemaUserResourceSetCreateBody
>;
export const schemaUserResourceSetCreateBody = z.object({
  title: z.string(),
  description: z.string().nullable().optional(),
  resourceSetDetails: z.array(
    z.object({
      resourceIds: z.array(z.number()),
      resourceType: ResourceTypeEnum,
      sort: z.number(),
    }),
  ),
});

export type UserResourceSetUpdateBody = z.infer<
  typeof schemaUserResourceSetUpdateBody
>;
export const schemaUserResourceSetUpdateBody = z.object({
  title: z.string(),
  description: z.string().nullable().optional(),
  resourceSetDetails: z.array(
    z.object({
      resourceIds: z.array(z.number()),
      resourceType: ResourceTypeEnum,
      sort: z.number(),
    }),
  ),
});
